import { render, staticRenderFns } from "./CrossSellOverview.vue?vue&type=template&id=011802a6"
import script from "./CrossSellOverview.vue?vue&type=script&lang=js"
export * from "./CrossSellOverview.vue?vue&type=script&lang=js"
import style0 from "./CrossSellOverview.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CrossSell: require('/builds/gladwell/gladwell-academy-frontend/components/CrossSell/CrossSell.vue').default})
